export const aboutInfo = {
  brandName: '亚洲春色',
  slogan: '感受春日亚洲最美风情',
  introduction:
    '亚洲春色是一个专注于亚洲春季旅行的中文内容平台，致力于为华语旅行者呈现东亚、东南亚、南亚最绚烂的春日自然与人文景观。我们相信，春天是亚洲最美的季节——从日本的樱花到尼泊尔的杜鹃，从越南会安的灯笼到印度大吉岭的茶园，每一处春色都值得被记录和分享。',
  story:
    '亚洲春色创立于2020年春天，由一群热爱亚洲文化和自然风光的旅行者共同发起。我们在疫情期间开始记录亚洲各地的春日美景，希望用文字和影像将春天的希望传递给更多人。如今，亚洲春色已经成为华语旅行圈中最具影响力的春季旅行指南之一，每年为数以万计的旅行者提供春季出行灵感。',
  values: [
    {
      title: '真实体验',
      description: '每一位作者都亲自到访过所写的目的地，确保内容的真实性和可靠性。',
    },
    {
      title: '文化尊重',
      description: '我们倡导深度旅行，尊重每一个目的地的文化传统和自然环境。',
    },
    {
      title: '可持续旅行',
      description: '倡导负责任的旅行方式，保护亚洲珍贵的自然与文化遗产。',
    },
  ],
  stats: [
    { value: '50+', label: '覆盖目的地' },
    { value: '200+', label: '原创文章' },
    { value: '100万+', label: '年阅读量' },
    { value: '8万+', label: '忠实读者' },
  ],
  reviews: [
    {
      name: '张先生',
      location: '北京',
      content:
        '亚洲春色的日本樱花攻略做得太详细了！按照上面的路线规划，今年三月我终于圆了京都赏樱的梦想。每一处推荐都准确无误，而且打卡点的拍照角度都标注得清清楚楚。强烈推荐！',
      rating: 5,
      date: '2026-04-15',
    },
    {
      name: '李女士',
      location: '上海',
      content:
        '跟着亚洲春色去了一趟清迈花卉节，简直美哭了！文章里推荐的小众景点比网红打卡点更惊喜，而且详细写出了最佳游览时间，避开了大批游客。已经推荐给了身边所有喜欢旅行的朋友。',
      rating: 5,
      date: '2026-03-28',
    },
    {
      name: '王小姐',
      location: '广州',
      content:
        '第一次去尼泊尔徒步，全靠亚洲春色的博卡拉杜鹃花季攻略。从行前准备到路线选择，再到住宿推荐，信息太全了。在布恩山看到日照金山的那一刻，真的觉得此生无憾。',
      rating: 5,
      date: '2026-05-02',
    },
  ],
  contact: {
    email: 'contact@hvrxld.cn',
    phone: '+86 400-888-8888',
    address: '中国上海市浦东新区世纪大道100号',
    wechat: 'AsiaSpringOfficial',
    weibo: '@亚洲春色官方',
  },
  faqs: [
    {
      question: '亚洲春色的内容是否免费？',
      answer: '是的，亚洲春色的所有文章和攻略内容对读者完全免费开放。我们希望通过免费的内容帮助更多人探索亚洲春季的美好。',
    },
    {
      question: '文章中的信息如何保证时效性？',
      answer: '我们的作者团队会定期回访目的地，更新花况、交通、门票等时效性信息。每篇文章末尾都会标注最后更新日期，方便读者判断信息的新鲜度。',
    },
    {
      question: '如何成为亚洲春色的撰稿人？',
      answer: '我们欢迎热爱旅行和写作的朋友加入作者团队。请将您的个人简介和一篇样稿发送至我们的邮箱，编辑团队会在7个工作日内回复。',
    },
    {
      question: '亚洲春色的旅行攻略适合自由行吗？',
      answer: '非常适合！我们的攻略专门为自由行旅行者设计，从签证、交通、住宿到每日行程规划都有详细说明，即使是第一次出国也能轻松上路。',
    },
  ],
};